// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import * as selectors from '../../../reducers';
import type { ROUTE_TYPE } from '../../../types/routes';
import type { MONITOR_TYPE } from '../../../types/monitors';
import styles from '../monitorCard.css';

type RoutesPanelPropTypes = {
  monitorRoutes: Array<ROUTE_TYPE>,
  monitor: MONITOR_TYPE,
  startAddMonitorRoute: Function,
};

const RoutesPanel = ({ monitorRoutes, monitor, startAddMonitorRoute }: RoutesPanelPropTypes) => (
  <Fragment>
    <p className={styles.label}>{i18n.t('labels.assignedRoutes')}</p>
    {
      monitorRoutes.map(route => (
        <div className={styles.routeContainer}>
          <p className={styles.routeTitle}>
            {route.name}
          </p>
          <p className={styles.routeType}>
            {route.route_type && (route.route_type === 'going' ? 'Recolección' : 'Entrega')}
          </p>
        </div>
      ))
    }
  </Fragment>

);

const RoutesPanelComponent = connect(
  (state, { monitor }) => {
    const monitorRoutes = selectors.getMonitorRoutes(state, monitor.id);
    return {
      monitorRoutes,
    };
  },
  undefined,
)(RoutesPanel);


export default RoutesPanelComponent;



// WEBPACK FOOTER //
// ./src/scripts/components/MonitorCard/RoutesPanel/index.jsx